import { render, staticRenderFns } from "./line_break.vue?vue&type=template&id=4e659bd6&lang=pug&"
import script from "./line_break.vue?vue&type=script&lang=js&"
export * from "./line_break.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e659bd6', component.options)
    } else {
      api.reload('4e659bd6', component.options)
    }
    module.hot.accept("./line_break.vue?vue&type=template&id=4e659bd6&lang=pug&", function () {
      api.rerender('4e659bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/typography/line_break.vue"
export default component.exports